import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from '../../../utils/consts';
import { injectMethods } from '../../../utils/vue';
import ComponentDefaultPropPanel from "../PropPanel/index";
import ErrorBoundary from '../../ErrorBoundary';
import { getCompActionRenderType } from '../../../designer/utils/compActions';
const __script_base__ = {
  name: 'PropPanel',
  inject: {
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    },
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    }
  },
  props: {
    compPath: {
      type: String,
      required: true
    }
  },
  components: {
    ComponentDefaultPropPanel,
    ErrorBoundary
  },
  computed: {
    actions() {
      return this.designer.getActiveCompActions('propPanel').map(x => ({
        ...x,
        _renderType: getCompActionRenderType(x)
      }));
    },
    propPanelComponent() {
      var _this$compMeta;
      const mainPropPanel = (_this$compMeta = this.compMeta) === null || _this$compMeta === void 0 || (_this$compMeta = _this$compMeta.propPanel) === null || _this$compMeta === void 0 ? void 0 : _this$compMeta.main;
      /**
       * mainPanel的设置支持两种形式
       *
       * main: component
       *
       * main: {
       *  component,
       *  ... // 其余配置项
       * }
       */
      return (mainPropPanel === null || mainPropPanel === void 0 ? void 0 : mainPropPanel.component) || mainPropPanel;
    },
    comp() {
      return this.designer.getCompAtPath(this.compPath);
    },
    compMeta() {
      var _this$comp;
      return this.uc.components[(_this$comp = this.comp) === null || _this$comp === void 0 ? void 0 : _this$comp.type];
    }
  },
  methods: {
    ...injectMethods('designer', ['executeAction'])
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-propPanel"
  }, [_vm.actions.length ? _c("div", {
    staticClass: "ucdProps_actions"
  }, [_vm._l(_vm.actions, function (action, index) {
    return [action._renderType === "action" ? _c("button", {
      key: "action:" + index,
      staticClass: "uc-button ucdProps_action_button",
      class: {
        isHighlighted: action.highlighted,
        isPrimary: action.primary
      },
      attrs: {
        disabled: !!action.disabled,
        title: action.desc
      },
      on: {
        click: function (e) {
          return _vm.executeAction(action.execute, e);
        }
      }
    }, [!action.icon ? void 0 : action.icon.includes("fa-") ? _c("i", {
      staticClass: "ucdProps_action_icon",
      class: action.icon
    }) : _c("img", {
      staticClass: "ucdProps_action_img_icon",
      attrs: {
        src: action.icon
      }
    }), _vm._v(" "), _c("span", {
      staticClass: "ucdProps_action_title"
    }, [_vm._v("\n          " + _vm._s(action.title) + "\n        ")])], 2) : _vm._e(), _vm._v(" "), action._renderType === "separator" ? _c("hr", {
      key: "action:" + index,
      staticClass: "ucdProps_action_hr"
    }) : _vm._e(), _vm._v(" "), action._renderType === "text" ? _c("span", {
      key: "action:" + index,
      staticClass: "ucdProps_action_text"
    }, [_vm._v("\n        " + _vm._s(action.title) + "\n      ")]) : _vm._e()];
  })], 2) : _vm._e(), _vm._v(" "), _c("ErrorBoundary", [_c(_vm.propPanelComponent || "ComponentDefaultPropPanel", {
    key: _vm.compPath + "-" + _vm.comp.componentId + "-" + _vm.comp.type,
    tag: "component",
    attrs: {
      "comp-path": _vm.compPath
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/components/PropPanel.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);